import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Va from "./pages/Va";
import Cc from "./pages/Cc";
import ScrollToTop from "./components/ScrollTop";
import Loading from "./components/loader/Loader";
import { useState, useEffect } from "react";
import { client } from "./sanityClient";

const App = () => {
  const [portfolio, setPortfolio] = useState(null);
  useEffect(() => {
    client
      .fetch(
        `*[_type == "portfolio"][0]{
        intro,
        servicesSection,
        about,
        recentWorks,
        testimonials,
        contentBlog,
        voiceActingBlog,
        links,
        parties
      }`
      )
      .then((data) => setPortfolio(data))
      .catch(console.error);
  }, []);

  if (!portfolio) return <Loading />;

  // Combine all videos from both blogs
  const allVideos = [
    ...(portfolio.contentBlog?.posts || []).map((video) => ({
      ...video,
      category: "content creation",
    })),
    ...(portfolio.voiceActingBlog?.posts || []).map((video) => ({
      ...video,
      category: "voice acting",
    })),
    ...(portfolio.parties?.posts || []).map((video) => ({
      ...video,
      category: "parties",
    })),
  ];

  return (
    <Router>
      <div className={`app`}>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={<Home data={portfolio} allVideos={allVideos} />}
          />
          {/* <Route
            path="/voice-acting"
            element={<Va data={portfolio.voiceActingBlog} />}
          />
          <Route
            path="/content-creation"
            element={<Cc data={portfolio.contentBlog} />}
          /> */}
        </Routes>
      </div>
    </Router>
  );
};

export default App;
